import { ReactNode } from "react";

export enum FormFieldColors {
  Light = "light",
  Neutral = "neutral",
}

export enum FormFieldStatus {
  Error = "error",
  Warning = "warning",
  Info = "info",
  Success = "success",
}

export interface FormFieldMessageProps {
  message?: string;
  status?: FormFieldStatus;
}

export interface FormFieldLabelProps {
  required?: boolean;
  label?: ReactNode;
  info?: ReactNode;
  labelDecoration?: ReactNode;
  optionalLabel?: string;
}
